import TopPerformingSitesCard from './TopPerformingSitesCard';

export default TopPerformingSitesCard;
